import { assetRequestInterceptorFactory } from '@adjust/dashboard-core/api/instance/asset-request-interceptor-factory/asset-request-interceptor-factory';

function AssetRequestInterceptor() {
  'ngInject';
  return {
    request: assetRequestInterceptorFactory('/account'),
  };
}

export { AssetRequestInterceptor };
